import SockJS from "sockjs-client"
import Stomp from "stompjs"
import router from "@/router"
import { Notification } from "element-ui"
import store from "@/store/index"
import { messageTypeMap } from "@/views/System/MessageCenter/static"
import * as MessageApi from "@/api/userCenter/message"
import { setUnreadMessageCount } from "@/store/actions"
import _ from "lodash"

// 初始化
let sock, stomp

function handleMessage(socketMsg) {
  try {
    let jsonBody = JSON.parse(socketMsg.body)
    let { type, content, extra } = jsonBody
    let title = messageTypeMap[type]
    if (!title) {
      console.error("消息类型不合法", jsonBody)
      return
    }
    if (["IMPORT", "EXPORT"].includes(type) && /https:\/\/new-service/.test(extra)) {
      let tip = type === "IMPORT" ? "下载查看失败原因" : "下载查看导出结果"
      content += `&nbsp;<a style="text-decoration: none;color: #1989FA;" href='${extra}'>${tip}</a>`
    }
    if (type === "COMMON") {
      content += `&nbsp;<a style="color:#1989FA;float:right;">查看详情</a>`
    }
    if (type === "TASK") {
      title = content
      content = extra.name
    }
    debouncedRefreshCount()
    document.getElementById("chatAudio").play()
    let notification = Notification({
      title,
      message: content,
      dangerouslyUseHTMLString: true,
      duration: 5000,
      onClick: () => {
        router.push({
          name: "system-message",
          params: { from: "notify", content: content, type: type }
        })
        notification.close()
      }
    })
  } catch (e) {
    console.error("消息不合法", socketMsg)
  }
}

let debouncedRefreshCount = _.debounce(
  () => MessageApi.getUnreadMessageCount().then(count => setUnreadMessageCount(count)),
  500,
  { leading: true, trailing: true }
)

// 订阅消息
function subscribe() {
  // 集体消息
  stomp.subscribe("/topic/shouts", handleMessage)
  // 个人消息
  stomp.subscribe("/user/queue", handleMessage)
}

// 发起连接
export function launchConnect() {
  if (store.getters.socketStatus != "Unconnected") return false
  sock = new SockJS("/message")
  stomp = Stomp.over(sock)
  stomp.debug = false
  store.dispatch("app/changeSocketStatus", "Pending")
  connect()
}

// 连接
function connect() {
  stomp.connect(
    {}, // headers
    () => {
      // connectCallback
      store.dispatch("app/changeSocketStatus", "Connected")
      subscribe()
    },
    () => {
      // errorCallback
      setTimeout(() => {
        if (store.getters.socketStatus == "Pending") connect()
      }, 2000)
    }
  )
}

// 断开连接
export function disconnect() {
  if (store.state.app.socketStatus != "Connected") return Promise.resolve()
  return new Promise((resolve, reject) => {
    if (store.getters.socketStatus != "Unconnected")
      stomp.disconnect(() => {
        afterDisconnect()
        resolve()
      })
    else {
      afterDisconnect()
      resolve()
    }
  })
}

function afterDisconnect() {
  sock = null
  stomp = null
  store.dispatch("app/changeSocketStatus", "Unconnected")
}
